import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickReturnMainScreen = () => {

        navigate(`/administrador/cajas/gestiones`)

    }

    const handleClickFetchSpecificManagement = async (idexpense) => {
        
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificExpense } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificExpense

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idexpense: idexpense})
        executeFetch()


    }

    const handleClickDeleteManagement = async (idexpense) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/cashier-managements/delete-expense/${idexpense}`)
                .then(({ data }) => {
                    
                    alertMessage(data)

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
            
        // const enlaceTemporal = document.createElement('a');
        // enlaceTemporal.href = openUrl;
        // enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
        // document.body.appendChild(enlaceTemporal);
        // enlaceTemporal.click();
        // document.body.removeChild(enlaceTemporal);

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
        
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
        
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
        
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

            } catch (error) {
            console.error('Error al descargar la imagen', error);
            }

    }

    const handleClickCurrencyConverter = () => {

        const { FormScreen } = Forms

        const new_monto_convertido = parseFloat(FormScreen.formState.monto_solicitado) * parseFloat(FormScreen.formState.tipo_cambio)

        // Se convierte a String para usar el onInputNumberChange
        const str_monto_convertido = parseFloat(new_monto_convertido)
            .toLocaleString('en-US', {
                minimumFractionDigits: 2, maximumFractionDigits: 2
            }) || ''

        // Se setea los valores
        FormScreen.onInputNumberChange({
            target: {
                name: 'monto_convertido',
                value: str_monto_convertido || '0'
            }
        })

    }

    const _defalutApproval = async () => {

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        // ---------------------------------------------------------------------------------
        if(
            FormScreen.formState.idgestiontipo === 4 // REINTEGRO DE EFECTIVO
            && FormScreen.formState.aprobacion_check === 'Reintegro Congelado' // REINTEGRO DE EFECTIVO
            && (
                FormScreen.formState.numero_comprobante === ''
                || FormScreen.formState.acceptedFiles.length <= 0
            )
        ){
            alertMessage({ message: 'Es necesario que complete la información del cheque para continuar', flag: 'FAIL', rows: [] })
            return
        }

        // ---------------------------------------------------------------------------------
        const _dataBody = new FormData();
        _dataBody.append('idgestion', formState.idgestion)
        _dataBody.append('idgestiontipo', formState.idgestiontipo)
        _dataBody.append('user', user.username)
        _dataBody.append('monto_aprobado', formState.monto_aprobado)
        _dataBody.append('idbanco', formState.idbanco)
        _dataBody.append('numero_comprobante', formState.numero_comprobante)
        _dataBody.append('aprobacion_check', formState.aprobacion_check)
        _dataBody.append('aprobacion_fecha', formState.aprobacion_fecha)
        _dataBody.append('aprobacion_observaciones', formState.aprobacion_observaciones)

        // ---------------------------------------------------------------------------------
        if(
            FormScreen.formState.idgestiontipo === 4 // REINTEGRO DE EFECTIVO
        ){
            FormScreen.formState.acceptedFiles.forEach((file, index) => {
                _dataBody.append(`images`, file);
            });
        }

        // ---------------------------------------------------------------------------------
        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        
        await marvarApi.post( `/cashier-managements/admin/save-approval`, _dataBody )
            .then(({ data }) => {
                
                alertMessage(data)
                onResetForm()
                handleClickReturnMainScreen()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    const _createManagement = async () => {
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const {
            getBodyBuyingSellingDollars
        } = Helpers

        let _dataBody = {}

        switch(formState.idgestiontipo) {
            case 7: { // (CENTRALES) COMPRA Y VENTA DE DOLARES
                _dataBody = getBodyBuyingSellingDollars(FormScreen, user)
                break
            }
            default:
                console.log('___error, no es posible identificar el tipo de gestión')
                return
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        // return

        await marvarApi.post( `/cashier-managements/admin/create-management`, _dataBody )
            .then(({ data }) => {
                
                alertMessage(data)
                onResetForm()
                handleClickReturnMainScreen()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }
    
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState } = FormScreen

        if (formState.idgestion > 0 && formState.idgestion !== ''){
            await _defalutApproval()
            return
        } else {
            await _createManagement()
            return
        }
        
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickReturnMainScreen,
        handleClickFetchSpecificManagement,
        handleClickDeleteManagement,
        handleClickDownloadImage,
        handleClickCurrencyConverter,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}